import { MaintenanceRequestDto, MaintenanceRequestSearchResponseDto } from "@inosio/payments-sdk";
import { createSlice } from "@reduxjs/toolkit";
import { ErrorType, RootState } from "../../../app/store";

interface IMaintenanceRequestDataPage {
  Rows: Array<MaintenanceRequestDto>;
}
type MaintenanceState = {
  //creating a maintenance request
  maintenanceRequestCreationResponse: MaintenanceRequestDto;
  isCreatingMaintenanceRequest: boolean;
  isMaintenanceRequestCreationSuccess: boolean;
  maintenanceRequestCreationFailed: boolean;
  maintenanceRequestCreationError: ErrorType;

  //fetching all maintenance requests
  isFetchingAllMaintenanceRequests: boolean;
  isFetchingAllMaintenanceRequestsFailed: boolean;
  isFetchingAllMaintenanceRequestsSuccess: boolean;
  MaintenanceRequestFetchResponseDto: MaintenanceRequestSearchResponseDto;
  MaintenanceRequestDataPages: Array<IMaintenanceRequestDataPage>;
  MaintenanceRequestFetchError: ErrorType;

  //fetching inprogress maintenancerequests
  isFetchingInProgressMaintenanceRequests: boolean;
  isFetchingInProgressMaintenanceRequestsFailed: boolean;
  isFetchingInProgressMaintenanceRequestsSuccess: boolean;
  InProgressMaintenanceRequestFetchResponseDto: MaintenanceRequestSearchResponseDto;
  InProgressMaintenanceRequestFetchError: ErrorType;
};
const getInitialState = () => {
  return {
    //creating a maintenance request
    maintenanceRequestCreationResponse: {} as MaintenanceRequestDto,
    isCreatingMaintenanceRequest: false,
    isMaintenanceRequestCreationSuccess: false,
    maintenanceRequestCreationError: {} as ErrorType,
    maintenanceRequestCreationFailed: false,

    //fetching all maintenance requests
    isFetchingAllMaintenanceRequests: false,
    isFetchingAllMaintenanceRequestsFailed: false,
    isFetchingAllMaintenanceRequestsSuccess: false,
    MaintenanceRequestDataPages: [],
    MaintenanceRequestFetchResponseDto: {} as MaintenanceRequestSearchResponseDto,
    MaintenanceRequestFetchError: {} as ErrorType,

    //fetching inprogress maintenancerequests
    isFetchingInProgressMaintenanceRequests: false,
    isFetchingInProgressMaintenanceRequestsFailed: false,
    isFetchingInProgressMaintenanceRequestsSuccess: false,
    InProgressMaintenanceRequestFetchResponseDto: {} as MaintenanceRequestSearchResponseDto,
    InProgressMaintenanceRequestFetchError: {} as ErrorType,
  } as MaintenanceState;
};

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState: getInitialState(),
  reducers: {
    getCreateMaintenanceRequest(state, action) {
      state.isCreatingMaintenanceRequest = true;
      state.maintenanceRequestCreationError = {} as ErrorType;
      state.isMaintenanceRequestCreationSuccess = false;
      state.maintenanceRequestCreationFailed = false;
    },
    setNewMaintenanceRequest(state, action) {
      const response = {
        isMaintenanceRequestCreationSuccess: true,
        isCreatingMaintenanceRequest: false,
        maintenanceRequestCreationResponse: action.payload,
      };
      return { ...state, ...response };
    },
    setMaintenanceRequestCreationError(state, action) {
      state.isMaintenanceRequestCreationSuccess = false;
      state.isCreatingMaintenanceRequest = false;
      state.maintenanceRequestCreationFailed = true;
      state.maintenanceRequestCreationError = action.payload;
    },
    getAllMaintenanceRequests(state) {
      state.isFetchingAllMaintenanceRequests = true;
      state.isFetchingAllMaintenanceRequestsFailed = false;
      state.isFetchingAllMaintenanceRequestsSuccess = false;
    },
    setAllMaintenanceRequests(state, action) {
      state.isFetchingAllMaintenanceRequests = false;
      state.isFetchingAllMaintenanceRequestsSuccess = true;

      let _payload = action.payload as MaintenanceRequestSearchResponseDto;

      //get a copy of the current book
      let currentMaintenancePages = [...state.MaintenanceRequestDataPages];

      //if startindex = 0, just reset the book because that means it's loading for the first time or he reset the range size
      if (_payload.StartIndex === 0) currentMaintenancePages = [];

      //find out what page we are on
      let whatPageResultsIsThis = Math.ceil((_payload.StartIndex ?? 0) / (_payload?.RangeSize ?? 0));

      //now, add this new data page to our book
      currentMaintenancePages[whatPageResultsIsThis] = {
        Rows: _payload?.Rows,
      };

      //return the full
      state.MaintenanceRequestFetchResponseDto = action.payload;
      state.MaintenanceRequestDataPages = currentMaintenancePages;
    },
    setMaintenanceRequestFetchError(state, action) {
      state.isFetchingAllMaintenanceRequests = false;
      state.isFetchingAllMaintenanceRequestsFailed = true;
      state.isFetchingAllMaintenanceRequestsSuccess = false;
      state.MaintenanceRequestFetchError = action.payload;
    },
    getInProgressMaintenanceRequests(state) {
      state.isFetchingInProgressMaintenanceRequests = true;
      state.isFetchingInProgressMaintenanceRequestsFailed = false;
      state.isFetchingInProgressMaintenanceRequestsSuccess = false;
    },
    setInProgressMaintenanceRequests(state, action) {
      state.isFetchingInProgressMaintenanceRequests = false;
      state.isFetchingInProgressMaintenanceRequestsSuccess = true;
      state.InProgressMaintenanceRequestFetchResponseDto = action.payload;
    },
    setInProgressMaintenanceRequestFetchError(state, action) {
      state.isFetchingInProgressMaintenanceRequests = false;
      state.isFetchingInProgressMaintenanceRequestsFailed = true;
      state.isFetchingInProgressMaintenanceRequestsSuccess = false;
      state.InProgressMaintenanceRequestFetchError = action.payload;
    },
    resetMaintenanceState(state) {
      return getInitialState();
    },
    resetCreateMaintenanceState(state){
      state.isCreatingMaintenanceRequest= false;
      state.isMaintenanceRequestCreationSuccess= false;
      state.maintenanceRequestCreationError= {} as ErrorType;
      state.maintenanceRequestCreationFailed= false;
    }
  },
});
export const { 
  getCreateMaintenanceRequest,
  setNewMaintenanceRequest, 
  setMaintenanceRequestCreationError, 
  getAllMaintenanceRequests, 
  setAllMaintenanceRequests, 
  setMaintenanceRequestFetchError,
  getInProgressMaintenanceRequests,
  setInProgressMaintenanceRequestFetchError,
  setInProgressMaintenanceRequests,
  resetMaintenanceState,
  resetCreateMaintenanceState,
} = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
export const selectMaintenanceState = (state: RootState) => state.maintenanceState;
export const selectMaintenanceHistoryCurrentPage = (state: RootState) => state.maintenanceState.MaintenanceRequestDataPages;
